module.exports = __webpack_public_path__ + "static/media/devilEye.718dbce2.png";